enum StatutCompletion {
  ACompleter = "A_COMPLETER",
  Terminee = "TERMINEE",
}

export default StatutCompletion;
